var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-box"},[_c('BankDetails',{attrs:{"data":_vm.data[_vm.bankDetailsName] || {}}}),_vm._l((_vm.orderedServiceDetails),function(fieldValue,fieldName){return _c('WrapperField',{key:fieldValue + fieldName + Math.random(),attrs:{"data":_vm.createDataField({
        fieldName: fieldName,
        fieldValue: fieldValue,
        fieldGroup: _vm.serviceDetailsName,
      })}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }